import * as React from 'react'
import {Link as RouterLink} from "react-router-dom";
import {Link} from "@mui/material";

import {LabelCountry} from "@components";
import { MARKETPLACES_ROUTES } from "@constants"
import { country, seller } from "@signals"


export default function sellerColumn() {
	return {
		name: 'seller', label: 'Seller',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, dataRow) => {
				const handleClick = () => {
					country.value = [dataRow.country]
					seller.value = [dataRow.sellerID]
				}

				return <Link
					component={RouterLink}
					to={`${MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_PATH}?launch=true`}
					onClick={handleClick}
				>
					{value}
				</Link>
			}
		}
	}
}